import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListLastRecordedActivityCell } from './charge-point-list-last-recorded-activity.cell';
import { ChargePointListLastRecordedActivityHeader } from './charge-point-list-last-recorded-activity.header';

export const ChargePointListLastRecordedActivityColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['lastRecordedActivityDate']
> = {
  enableSorting: true,
  header: ChargePointListLastRecordedActivityHeader,
  cell: ChargePointListLastRecordedActivityCell,
};
